export default /* html */ `
    <div class="all-wrapper">
      <div class="product-title-wrapper">
        <div class="title-header">
          <div class="title">상품 상세페이지</div>
        </div>
        <div class="button-wrapper">
          <div class="edit">
            <a href="/editproduct/" class="edit-button">수정</a>
          </div>
          <div class="delete">
            <a class="delete-button" href="/product" class="delete-button">삭제</a>
          </div>
        </div>
      </div>
      <div class="product-item-wrapper">
        <div class="bar"></div>
        <div class="product-info skeleton-loading">
          <div class="product-info-wrapper">
            <div class="product-thumbnail">
            </div>
            <div class="product-info-text">
              <div class="category">
                <div class="title"></div>
              </div>
              <div class="name">
                <div class="title"></div>
              </div>
              <div class="price">
                <div class="title"></div>
              </div>
              <div class="sale">
                <div class="title"></div>
              </div>
              <div class="tag">
                <div class="title"></div>
              </div>
            </div>
          </div>
          <div class="bar"></div>
          <div class="detail-img">
            <img src="" alt="" />
          </div>
        </div>
      </div>
    </div>`;
